<template>
  <div>
    <vx-card>
      <List :subjectPermission="subjectPermission"></List>
    </vx-card>
  </div>
</template>

<script>
import List from "./ListCaixasItens";

export default {
  data() {
    return {
      subjectPermission: "CaixasItens"
    };
  },
  methods: {},
  components: {
    List
  }
};
</script>
